
import { useState } from "react";
import { ToastContainer } from "react-toastify";
import { SERVER_PATH } from "../../config/env";
import { successToaster } from "../../utils";
import apiClient from "../../utils/api";

function SliderUpload(props) {
  const { imgId = 1 } = props;
  const [data, setData] = useState([]);
  const [imgData, setImgData] = useState([]);

  const onChangeHandler = (e) => {
    if (e.target.name === "img") {
      setData({ ...data, ["img"]: URL.createObjectURL(e.target.files[0]) });
    } else {
      setData({ ...data, [e.target.name]: e.target.value });
    }
    setImgData(e.target.files[0]);
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const file = imgData;
    const base64 = await convertToBase64(file);
    apiClient
      .post(`put/user_landingpage.php`, {
        path: base64,
        link: data.link,
        image_id: imgId,
      })
      .then(() => {
        successToaster({ msg: "Slide upload successfully" });
        setData("");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <form id="fistSlide" className="tab-pane active" onSubmit={onSubmit}>
        <div className="mt-2">
          <input
            type="text"
            placeholder="ENTER SLIDE LINK"
            className="p-1 linkInput"
            required
            name="link"
            onChange={onChangeHandler}
          />
          <div className="button-wrapper py-2">
            <span className="label">Upload File</span>
            <input
              required
              type="file"
              id="upload"
              className="upload-box"
              name="img"
              onChange={onChangeHandler}
            />
          </div>
          <div className="previewDiv">
            {data?.img && (
              <img src={data?.img} height="200" width="200" alt="med1" />
            )}
          </div>
        </div>
        <div className="py-2 text-center submitBtn">
          <button className=" text-uppercase">{props.buttonText}</button>
        </div>
      </form>
      <ToastContainer />
    </>
  );
}
export default SliderUpload;
